import { Box, useTheme } from '@mui/material';
import NavigationTabsComponent from '@/components/jugadores-v2/information/Tabs/NavigationTabsComponent';
import { Rutas } from '@/constants/rutas';
import FantasyLaLigaIcon from '@/components/shared/icons/fantasy-la-liga-icon';
import FantasyMarcaIcon from '@/components/shared/icons/FantasyMarcaIcon';
import MisterFantasyIcon from '@/components/shared/icons/MisterFantasyIcon';
import CustomImageComponent from '@/components/shared/custom/custom-image';

const JugadoresTabsSection = ({ activeTab, activeSubTab, slug }) => {
    const theme = useTheme();

    const createTabLabel = (label, icon) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {icon}
            {label}
        </Box>
    );

    const tabs = [
        {
            label: 'Información',
            url: `${Rutas.JUGADORES}/${slug}`,
        },
        {
            label: 'Puntos',
            url: `${Rutas.JUGADORES}/puntos-la-liga-fantasy/${slug}`,
        },
        {
            label: 'Minutos',
            url: `${Rutas.JUGADORES}/minutos-disputados/${slug}`,
        },
        {
            label: 'Mercado',
            url: `${Rutas.JUGADORES}/subidas-mercado-la-liga-fantasy/${slug}`,
            subTabs: [
                {
                    label: createTabLabel('Fantasy', <FantasyLaLigaIcon iconHeight={20} iconWidth={20} />),
                    url: `${Rutas.JUGADORES}/subidas-mercado-la-liga-fantasy/${slug}`,
                },
                {
                    label: createTabLabel(
                        'Biwenger',
                        <CustomImageComponent
                            src={`${process.env.NEXT_PUBLIC_IMAGES}/logos/biwenger-logo.png?width=50`}
                            alt="biwenger logo"
                            width={20}
                            height={20}
                        />
                    ),
                    url: `${Rutas.JUGADORES}/subidas-mercado-fantasy-biwenger/${slug}`,
                },
                {
                    label: createTabLabel('Fantasy Marca', <FantasyMarcaIcon width={20} height={20} />),
                    url: `${Rutas.JUGADORES}/subidas-mercado-fantasy-marca/${slug}`,
                },
                {
                    label: createTabLabel('Mister Fantasy', <MisterFantasyIcon width={20} height={20} />),
                    url: `${Rutas.JUGADORES}/subidas-mercado-mister-fantasy/${slug}`,
                },
            ],
        },
    ];

    return (
        <Box border={`1px solid ${theme.palette.border.main}`} borderRadius={1} width={'100%'}>
            <NavigationTabsComponent tabs={tabs} activeTab={activeTab} activeSubTab={activeSubTab} />
        </Box>
    );
};

export default JugadoresTabsSection;
